var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 2H21.9535V21.9539H2.00049V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65149 3.5C5.13049 3.5 3.50049 5.229 3.50049 7.904V16.05C3.50049 18.726 5.13049 20.454 7.65149 20.454H16.2975C18.8225 20.454 20.4535 18.726 20.4535 16.05V7.904C20.4555 6.541 20.0395 5.403 19.2515 4.614C18.5235 3.885 17.5045 3.5 16.3025 3.5H7.65149ZM16.2975 21.954H7.65149C4.27149 21.954 2.00049 19.581 2.00049 16.05V7.904C2.00049 4.373 4.27149 2 7.65149 2H16.3025C17.9105 2 19.2975 2.537 20.3125 3.554C21.3735 4.616 21.9555 6.161 21.9535 7.905V16.05C21.9535 19.581 19.6805 21.954 16.2975 21.954Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85672 7.68945C8.25272 7.68945 7.76172 8.18045 7.76172 8.78545C7.76172 9.38945 8.25272 9.88045 8.85772 9.88045C9.46172 9.88045 9.95372 9.38945 9.95372 8.78645C9.95272 8.18145 9.46072 7.69045 8.85672 7.68945ZM8.85772 11.3805C7.42572 11.3805 6.26172 10.2165 6.26172 8.78545C6.26172 7.35345 7.42572 6.18945 8.85772 6.18945C10.2887 6.19045 11.4527 7.35445 11.4537 8.78445V8.78545C11.4537 10.2165 10.2897 11.3805 8.85772 11.3805Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74893 20.1113C3.62493 20.1113 3.49893 20.0803 3.38293 20.0153C3.02093 19.8123 2.89393 19.3553 3.09593 18.9943C3.15593 18.8863 4.59093 16.3493 6.16993 15.0493C7.42193 14.0193 8.76993 14.5853 9.85593 15.0423C10.4949 15.3113 11.0989 15.5653 11.6789 15.5653C12.2109 15.5653 12.8779 14.6253 13.4679 13.7963C14.2869 12.6403 15.2169 11.3323 16.5789 11.3323C18.7489 11.3323 20.6219 13.2683 21.6289 14.3083L21.7449 14.4283C22.0329 14.7253 22.0259 15.2003 21.7289 15.4893C21.4339 15.7783 20.9589 15.7713 20.6689 15.4733L20.5509 15.3513C19.6989 14.4703 18.1129 12.8323 16.5789 12.8323C15.9909 12.8323 15.3009 13.8053 14.6899 14.6643C13.8519 15.8443 12.9849 17.0653 11.6789 17.0653C10.7959 17.0653 9.98693 16.7253 9.27393 16.4243C8.13993 15.9463 7.62593 15.7933 7.12293 16.2073C5.75893 17.3313 4.41693 19.7053 4.40393 19.7283C4.26693 19.9733 4.01193 20.1113 3.74893 20.1113Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/Image3.03580133a5d0246dbbc3b1ee0425cee0.svg";
export { ForwardRef as ReactComponent };